<template>
  <el-dialog
    title="商户发单状态"
    :visible.sync="dialogVisible"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    custom-class="minheight"
    width="70%"
  >
    <!--工具条-->
    <Toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      :selectBut="false"
    ></Toolbar>
    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
    >
      <el-table-column
        :label="$t('Name')"
        min-width="130"
        prop="BusinessConfig.Name"
      >
      </el-table-column>
      <el-table-column
        :label="$t('DateTime')"
        min-width="130"
        prop="TourDiy.ShippingDateTime"
      >
      </el-table-column>
      <el-table-column :label="$t('Status')" min-width="110">
        <template slot-scope="scope"
          ><el-tag
            :type="getShopStatusType(scope.row.Status)"
            disable-transitions
            >{{ $t("TourDiy.ShopStatusList")[scope.row.Status] }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="通知时间">
        <template slot-scope="scope">{{
          formatDateTime(scope.row.SendTime)
        }}</template>
      </el-table-column>
      <el-table-column :label="$t('operation')" width="130">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.Status == 1"
            type="success"
            size="small"
            :loading="sendLoading"
            @click="sendRemind(scope.row.Id)"
            >再次发送提醒</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <div slot="footer" class="dialog-footer"></div>
  </el-dialog>
</template>

<script>
import util from "util/date";
import { getUnconfirmedList, sendBusinessRemind } from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      currentRow: null,
      dialogVisible: false,
      sendLoading: false,
    };
  },
  methods: {
    getShopStatusType(Status) {
      switch (Status) {
        case 1:
          return "danger";
        case 2:
          return "warning";
        case 3:
          return "success";
      }
    },
    formatDateTime: function (val) {
      return util.formatDate.format(new Date(val), "MM-dd hh:mm");
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy/MM/dd hh:mm");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    sendRemind(id) {
      let _this = this;
      this.$confirm("确认发送吗？", "提示", {}).then(() => {
        this.sendLoading = true;
        let para = {
          id,
        };
        sendBusinessRemind(para).then((res) => {
          this.sendLoading = false;
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    //获取列表
    getList() {
      let _this = this;
      this.listLoading = true;
      let para = {
        page: this.page,
      };
      getUnconfirmedList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    loadData(id) {
      this.tid = id;
      this.getList();
      this.dialogVisible = true;
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList(
        "/Admin/GroupPurchase/Unconfirmed",
        routers
      );
    },
  },
};
</script>
